/**
 * Client-side configuration constants.
 * Server-side secrets (API keys) are never set here - they live in .env
 * and are only accessed by the Edge Function.
 */

/** Display name shown in the chat header and assistant messages. */
export const ASSISTANT_NAME = "Doze";

/**
 * Mutable API base URL. Defaults to same-origin (works with Netlify Dev and
 * when the widget is served from the same domain as the edge function).
 *
 * When the widget is embedded on mattresscrafters.com.au but the edge function
 * lives on mc-sleep-advisor.netlify.app, call setApiBaseUrl() with the full
 * Netlify URL before mounting (widget-entry.tsx reads data-api-url for this).
 */
let _apiBaseUrl = "";

export function setApiBaseUrl(baseUrl: string): void {
  // Strip trailing slash
  _apiBaseUrl = baseUrl.replace(/\/$/, "");
}

export function getChatApiEndpoint(): string {
  return `${_apiBaseUrl}/api/chat`;
}

/** Maximum number of messages kept in the session history sent to the API. */
export const MAX_HISTORY_MESSAGES = 20;

/** Welcome message shown before the user sends anything. */
export const WELCOME_MESSAGE = `Hi! I'm ${ASSISTANT_NAME}, your sleep advisor from Mattress Crafters. I'm here to help you find the right mattress for how you sleep.

To get started, could you tell me a bit about yourself? For example:
- Do you sleep on your back, side, or stomach?
- Do you have any aches or pain that affect your sleep?
- Are you buying for yourself or for you and a partner?`;
